export default defineNuxtRouteMiddleware(async (to) => {
  const userStore = useUserStore()
  const localePath = useLocalePath()

  // featureKeys live in the customer data, which loads reactively after auth.
  // Defer the check to the client, where the fetch settles deterministically.
  if (import.meta.server) return

  if (userStore.isAuthenticated && !userStore.data)
    await until(() => userStore.data).toBeTruthy({ timeout: 5000, throwOnTimeout: false })

  if (userStore.hasHybridSearchFeature)
    return navigateTo({ path: localePath('/hybrid-search'), query: to.query }, { replace: true })
})
